export const EMPTY_SPACE = '\u00A0';

export const RIGHT_ARROW = '\u2192';

export const ARABIC_LETTER_MARK = '\u061c';

export const DASH = '\u2013';

export const DASH_LONG = '\u2014';

export const LEMNISCATE = '\u221E';

export const FOUR_POINTED_STAR = '\u2726';

export const X = '\u00D7';

export const COLON = '\u003A';
